import React from 'react';

let update;
let clear;
let clearAll;

const radioShowsEpisodes = {
  radioShowsEpisodesData: null,
  singleRadioEpisodeRelatedData: null,
  update: (key, data) => update(key, data),
  clear: key => clear(key),
  clearAll: () => clearAll(),
};

clearAll = () => {
  Object.entries(radioShowsEpisodes).forEach((item) => {
    const [key, value] = item;

    if (typeof value !== 'function') {
      radioShowsEpisodes[key] = null;
    }
  });
};

update = (key, data) => {
  radioShowsEpisodes[key] = data;
};

clear = (key) => {
  radioShowsEpisodes[key] = null;
};

const RadioShowsEpisodesContext = React.createContext(radioShowsEpisodes);

export default RadioShowsEpisodesContext;
